var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.userHasRoles(['Quote Admin', 'Order Management']) &&
      (_vm.useMachineLayout(_vm.quote) || _vm.quote.isVentilationQuote())
  )?_c('v-list-item',{on:{"click":function($event){return _vm.generateOrderReview()}}},[_c('v-list-item-title',[_vm._v("Generate Order Review")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }